<template>
  <div>
    <b-nav pills vertical>
      <b-nav-item active>
        <router-link to="/news"><span>&#187;</span>平台新闻</router-link>
      </b-nav-item>
      <b-nav-item>
        <router-link to="/announcement"
          ><span>&#187;</span>通知公告</router-link
        >
      </b-nav-item>
    </b-nav>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
</style>
